import DefaultLayout from '##/Default';
import ListOrders from './List';
import Config from './Config';
import NotInEntrata from './NotInEntrata';
// import AmenityConfigForm from './AmenityConfigForm';


const routes = [
    {
        path: '/properties/orders',
        exact: true,
        layout: DefaultLayout,
        component: ListOrders,
        auth: true,
        title: 'Orders'
    },
    {
        path: '/orders/config',
        exact: true,
        layout: DefaultLayout,
        component: Config,
        auth: true,
        title: 'Config'
    },
    {
        path: '/properties/not_in_entrata',
        exact: true,
        layout: DefaultLayout,
        component: NotInEntrata,
        auth: true,
        title: 'Not In Entrata'
    }
];

export default routes;
